import styles from './index.module.sass';
import wheatImg from '@/modules/mixing/images/wheat.png';
import firstSvg from '@/modules/mixing/images/select-source-1.svg';
import secondSvg from '@/modules/mixing/images/select-source-2.svg';
import thirdSvg from '@/modules/mixing/images/select-source-3.svg';
import fourthSvg from '@/modules/mixing/images/select-source-4.svg';
import { WarehouseBagBunkerTemplate } from '@/shared/ui/bag-template/list/bunker';
import { Humidity } from '@/shared/ui/icons';
import { humidityLvlColor } from '@/modules/common/utils/get-humidity-color';

export const CultureItem = ({
  title,
  grainType,
  weight,
  temp,
  humidity,
  fallingNumber,
  id,
  idx,
  date,
  onClick,
  isSelected,
  type,
}: IArgs) => {
  return (
    <>
      {type === 2 ? (
        <div className={styles.root} onClick={() => !isSelected.state && onClick(+idx)}>
          <img className={styles.mainImg} src={wheatImg} alt="culture-image" />
          <div className={styles.grainData}>
            <div className={styles.topData}>
              <div className={styles.title}>
                <span className={styles.title}>{title}</span>
                <span className={styles.grainType}>{grainType}</span>
              </div>
              {isSelected.state && (
                <span
                  style={{
                    color:
                      isSelected.idx === 1
                        ? '#0870E2'
                        : isSelected.idx === 2
                        ? '#E73A42'
                        : '#007E3C',
                  }}
                  className={styles.selected}
                >
                  добавлено в калькулятор (компонент {isSelected.idx})
                </span>
              )}
              <div className={styles.sectionData}>
                <span className={styles.sectionId}>{id}</span>
                <span className={styles.sectionIdx}>место: {idx}</span>
              </div>
            </div>
            <div className={styles.bottomData}>
              <div className={styles.specs}>
                <SpecItem
                  icon={firstSvg}
                  value={`${isNaN(humidity) ? 'н/д' : humidity} %`}
                  humidity={humidity}
                />
                <SpecItem
                  icon={secondSvg}
                  value={`${isNaN(fallingNumber) ? 'н/д' : fallingNumber} %`}
                />
                <SpecItem icon={thirdSvg} value={`${isNaN(temp) ? 'н/д' : temp} °C`} />
                <SpecItem
                  icon={fourthSvg}
                  value={`${isNaN(weight) ? 'н/д' : weight} т`}
                />
              </div>
              <div className={styles.date}>
                {date?.split(' ')[0]?.replaceAll('-', '.')}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.bunker}>
          <div className={styles.bunkerWrap}>
            <svg
              className={styles.bgBadge}
              width="304"
              height="140"
              viewBox="0 0 304 140"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.40459 126.736L1.40466 126.736C28.6432 71.2088 70.6129 28.2785 112.779 9.02848C137.696 -2.34285 166.312 -2.34281 191.221 9.02848C233.387 28.2785 275.349 71.2088 302.595 126.736L303.044 126.516L302.595 126.736C305.431 132.513 301.254 139.249 294.811 139.249H152.004H9.18919C2.74558 139.249 -1.4314 132.513 1.40459 126.736Z"
                fill={'#FAF6E9'}
                stroke={'#EBD8A8'}
              />
            </svg>

            <div
              className={styles.data}
              onClick={() => !isSelected.state && onClick(+idx)}
            >
              {/* {mixed && <UiIcon className={styles.mixed} icon={<SimpleBunkerIcon />} />} */}

              <div className={styles.top}>
                <img className={styles.mainImg} src={wheatImg} alt="culture-image" />
              </div>
              <div className={styles.header}>
                <span className={styles.bunkerId}>
                  {id}{' '}
                  {isSelected.state && (
                    <span
                      style={{
                        color:
                          isSelected.idx === 1
                            ? '#0870E2'
                            : isSelected.idx === 2
                            ? '#E73A42'
                            : '#007E3C',
                      }}
                      className={styles.filled}
                    >
                      (компонент {isSelected.idx})
                    </span>
                  )}
                </span>
                <span className={styles.title}>
                  {grainType ? grainType : 'сорт не определен'}
                </span>
              </div>
              <div className={styles.specs}>
                <SpecItem
                  icon={firstSvg}
                  value={`${isNaN(humidity) ? 'н/д' : humidity} %`}
                  humidity={humidity}
                />
                <SpecItem
                  icon={secondSvg}
                  value={`${isNaN(fallingNumber) ? 'н/д' : fallingNumber} %`}
                />
                <SpecItem icon={thirdSvg} value={`${isNaN(temp) ? 'н/д' : temp} °C`} />
                <SpecItem
                  icon={fourthSvg}
                  value={`${isNaN(weight) ? 'н/д' : weight} т`}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

function SpecItem({
  icon,
  value,
  humidity,
}: {
  icon: string;
  value: string;
  humidity?: number;
}) {
  return (
    <div className={styles.specItem}>
      {humidity ? (
        <Humidity fill={humidityLvlColor(+humidity)} />
      ) : (
        <img src={icon} alt="spec-icon" />
      )}
      <span>{value}</span>
    </div>
  );
}

interface IArgs {
  title: string;
  grainType: string;
  weight: number;
  temp: number;
  humidity: number;
  fallingNumber: number;
  id: string;
  idx: number;
  date: string;
  onClick: (id: number) => void;
  isSelected: { state: boolean; idx: number };
  type: 1 | 2;
}
